import React from "react";
import { Box, TextField } from "@mui/material";
import QuickPeriodButtons from "./QuickPeriodButtons";

export default function PeriodFilters({ preset, onPresetChange, desde, hasta, setDesde, setHasta, showQuickButtons = true }) {
  const handlePreset = (next) => {
    if (!next) return;
    onPresetChange(next);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        alignItems: "center",
        justifyContent: showQuickButtons ? "space-between" : "flex-end",
        flexWrap: "wrap",
        py: 2.25,
      }}
    >
      {showQuickButtons && (
        <QuickPeriodButtons preset={preset} onPresetChange={handlePreset} />
      )}

      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <TextField
          size="small"
          label="Desde"
          type="date"
          value={desde}
          onChange={(ev) => {
            onPresetChange("custom");
            setDesde(ev.target.value);
          }}
          InputLabelProps={{ shrink: true }}
          sx={{ width: 150 }}
        />
        <TextField
          size="small"
          label="Hasta"
          type="date"
          value={hasta}
          onChange={(ev) => {
            onPresetChange("custom");
            setHasta(ev.target.value);
          }}
          InputLabelProps={{ shrink: true }}
          sx={{ width: 150 }}
        />
      </Box>
    </Box>
  );
}
